const React = require('react');
import Counter from '../../mui/counter.jsx';
const helper = require('../../../helper/dish-helper');
import { formatPrice, getUrlParam, isFormalMeal } from '../../../helper/common-helper';
import { formatMessage } from '../../../intl/helper';
import dishMenuMessages from '../../../intl/messages/dish-menu';
const classnames = require('classnames');
require('./cart-ordered-dish.scss');

const addDishes = getUrlParam('orderId');
const type = getUrlParam('type');

module.exports = React.createClass({
  displayName: 'CartOrderedDish',
  propTypes: {
    dish: React.PropTypes.object.isRequired,
    onOrderBtnTap: React.PropTypes.func.isRequired,
    expandDishFunc: React.PropTypes.func,
    ableAddPriceDiscount: React.PropTypes.bool,
    mustOrderInfo: React.PropTypes.object,
  },

  getInitialState() {
    return {
      expand: false,
    };
  },

  onOrderBtnTap(newCount, increment) {
    const { dish, onOrderBtnTap, isHDL } = this.props;
    const dishCountStep = this.getDishCountStep(increment);
    const count = helper.getDishesCount([dish]);
    if (dishCountStep < 0 && dish.key == sessionStorage.getItem('reducePriceKey') && count - 1 < 1) {
      sessionStorage.removeItem('reducePriceKey');
      sessionStorage.removeItem('reducePrice');
      sessionStorage.removeItem('reducePriceNum');
      // localStorage.removeItem('lastOrderedDishes')
    }
    if (newCount === 0 && isHDL) {
      this.props.showItemsReduce(true);
    }
    if (helper.isSingleDishWithoutProps(dish)) {
      onOrderBtnTap(dish, dishCountStep);
    } else {
      onOrderBtnTap(dish.updateIn(['order', 0, 'count'], count => helper.getNewCountOfDish(dish, dishCountStep) - count), dishCountStep);
    }
  },

  onExpandBtnTap(evt) {
    const { expandDishFunc } = this.props;
    this.setState({ expand: !this.state.expand }, () => {
      if (expandDishFunc) {
        expandDishFunc();
      }
    });
  },

  getDishCountStep(increment) {
    const { dish } = this.props;
    const dishCount = helper.getDishesCount([dish]);
    let dishCountStep = 0;

    if (increment < 0) {
      if (dishCount <= dish.dishIncreaseUnit) {
        dishCountStep = -dish.dishIncreaseUnit;
      } else if (dishCount - Math.abs(increment) < dish.dishIncreaseUnit) {
        dishCountStep = -dishCount;
      } else {
        dishCountStep = increment;
      }
    }

    return increment > 0 ? increment : dishCountStep;
  },

  getHasSelectedProps(dish) {
    return helper.containsSubPropertyDetail(dish);
  },

  getDiscountInfo(memberPrice, price) {
    return this.props.isMember && memberPrice < price ?
    (
      <span>
        <span
          className="detail-props-item-price price"
          style={{ textDecoration: 'line-through', color: 'rgb(153, 153, 153)' }}
        >
          {isNaN(price) || price <= 0 ? '0' : price}
        </span>
        <span className="detail-props-item-price detail-props-item-hcolor price">{isNaN(memberPrice) || memberPrice <= 0 ? '0' : memberPrice}</span>
      </span>
      ) :
      <span className="detail-props-item-price price">{isNaN(price) || price <= 0 ? '0' : price}</span>;
  },

  buildDetailInfo(dish) {
    if (helper.isGroupDish(dish)) {
      return this.buildDetailInfoForGroupDish(dish);
    }

    return this.buildDetailInfoForSingleDish(dish);
  },

  buildDetailInfoForSingleDish(dish) {
    const { dishPropertyTypeInfos, dishIngredientInfos } = dish.order[0];
    const RecipeProps = dishPropertyTypeInfos.filter(propInfo => propInfo.type === 1);
    const NoteProps = dishPropertyTypeInfos.filter(propInfo => propInfo.type === 3);

    const _this = this;
    function assemblePropsList(title, prop) {
      const { name, num, reprice, memberReprice } = prop || {};
      const count = title === '配料' ? num || 1 : 0;

      return (
        <li className="detail-props-item" key={`${name}${num}${reprice}`}>
          <span className="detail-props-item-name">{`${title}: ${name}`}</span>
          <span className="detail-props-item-info">
            <span className="detail-props-item-count">{`${count > 0 ? 'x' + count : ''}`}</span>
            {/* 加价折扣 */}
            {_this.getDiscountInfo(memberReprice, reprice)}
          </span>
        </li>
      );
    }

    function randomChar(l) {
      const x = '0123456789qwertyuioplkjhgfdsazxcvbnm';
      let tmp = '';
      const timestamp = new Date().getTime();
      for (let i = 0; i < l; i++) {
        tmp += x.charAt(Math.ceil(Math.random() * 100000000) % x.length);
      }
      return timestamp + tmp;
    }

    function buildPropsText(propsInfo) {
      const checkedProps = propsInfo.properties.filter(props => props.isChecked);
      const timestramp = randomChar(3);
      if (checkedProps.length > 0) {
        if (propsInfo.name === '备注') {
          const textAry = checkedProps.map(props => props.name);
          return (
            <ul key={timestramp}>
              <li>
                {propsInfo.name}: {textAry.join('、')}
              </li>
            </ul>
          );
        } else {
          let items = checkedProps.map(props => assemblePropsList(propsInfo.name, props));
          return <ul key={timestramp}>{items}</ul>;
        }
      }

      // if (checkedProps.length > 0) {
      //   return `${propsInfo.name}: ${checkedProps.map(props => props.name).join('、')}`;
      // }
      return '';
    }

    // return (
    //   <div className="detail-props-info">
    //     {RecipeProps.map(propInfo => buildPropsText(propInfo))
    //       .filter(propsText => propsText)
    //       .concat(
    //         [buildPropsText({ name: '配料', properties: dishIngredientInfos })].filter(propsText => propsText),
    //         NoteProps.map(propInfo => buildPropsText(propInfo)).filter(propsText => propsText)
    //       )
    //       .join(' | ')}
    //   </div>
    // );
    return (
      <div className="detail-props-info">
        {RecipeProps.map(propInfo => buildPropsText(propInfo))
          .filter(propsText => propsText)
          .concat(
            [buildPropsText({ name: '配料', properties: dishIngredientInfos })].filter(propsText => propsText),
            NoteProps.map(propInfo => buildPropsText(propInfo)).filter(propsText => propsText)
          )}
      </div>
    );
  },

  buildDetailInfoForGroupDish(dish) {
    const orderedChildDishes = [].concat
      .apply([], dish.order[0].groups.map(group => helper.getOrderedDishes(group.childInfos)))
      .filter(childDish => helper.getDishesCount([childDish]));

    return (
      <div className="ordered-dish-dropdown cart-ordered-dish-new">
        {orderedChildDishes.map((childDish, index) => {
          const isSingleDish = helper.isSingleDishWithoutProps(childDish);
          const { memberMarketPrice, marketPrice } = childDish;
          if (!isSingleDish) {
            return childDish.order.map((childDishX, idx) => {
              return (
                <div key={`${childDish.id}_${index}_${idx}`} className="child-dish-info">
                  <div className="child-dish-head">
                    <span className="child-dish-name">
                      {helper.generateDishNameWithUnit(childDish)}
                      {childDish.isReplace ? <span className="badge-bi" data-bi={formatMessage(dishMenuMessages.must)} /> : false}
                    </span>

                    <span className="o-flex__fixed child-dish-count">
                      <span className="child-dish-count-count">x{childDishX.count}</span>
                      {/* 加价折扣 */}
                      {this.getDiscountInfo(memberMarketPrice, marketPrice)}
                    </span>

                    {/* {childDish.marketPrice !== 0 ? (
                      <span className="child-dish-price badge-price">
                        {childDish.marketPrice > 0 ? '+' : ''}
                        <span className="price">{childDish.marketPrice}</span>
                      </span>
                    ) : (
                      false
                    )} */}

                    {/* <span className="child-dish-count">x{childDishX.count}</span> */}
                  </div>
                  {this.buildDetailInfoForSingleDish({ order: [childDishX] })}
                </div>
              );
            });
          }

          return (
            <div key={`${childDish.id}_${index}`} className="child-dish-info">
              <div className="child-dish-head">
                <span className="child-dish-name">{helper.generateDishNameWithUnit(childDish)}</span>

                <span className="o-flex__fixed child-dish-count">
                  <span className="child-dish-count-count">x{helper.getDishesCount([childDish])}</span>
                  {/* 加价折扣 */}
                  {this.getDiscountInfo(memberMarketPrice, marketPrice)}
                </span>

                {/* {childDish.marketPrice !== 0 ? (
                  <span className="child-dish-price badge-price">
                    {childDish.marketPrice > 0 ? '+' : ''}
                    <span className="price">{childDish.marketPrice}</span>
                  </span>
                ) : (
                  false
                )} */}
                {childDish.isReplace ? <span className="badge-bi" data-bi={formatMessage(dishMenuMessages.must)} /> : false}
                {/* <span className="child-dish-count">x{helper.getDishesCount([childDish])}</span> */}
                {helper.isSingleDishWithoutProps(childDish) ? false : this.buildDetailInfoForSingleDish(childDish)}
              </div>
            </div>
          );
        })}
      </div>
    );
  },
  getDishDataForObject(id) {
    const { COUNTER_SAVE_DISH_DATA = '{}' } = localStorage;
    const dishData = COUNTER_SAVE_DISH_DATA;

    return JSON.parse(dishData)[id];
  },
  render() {
    const { dish, showHandleInput, isHDL, isdiscount, reduceprice, ableAddPriceDiscount, mustOrderInfo } = this.props;
    const { expand } = this.state;
    const hasProps = this.getHasSelectedProps(dish);
    const detailInfo = hasProps ? this.buildDetailInfo(dish) : false;
    const { dishItem } = this.getDishDataForObject(dish.id) || this.props;
    const dishCount = helper.getDishesCount([dish]); // 菜品分数
    let dishPrice = formatPrice(helper.getDishPrice(dish)); // 总价格
    let dishMemberPrice = dish.isMember ? formatPrice(helper.getDishMemberPrice(dish) * dishCount) : -1; // 会员价基准价格
    let marketPrice = formatPrice(dish.marketPrice * dishCount); // 非会员价基准价格

    // 会员 && 会员价 && 商家打开加价折扣 -> 使用加价折扣计算 helper.getTotalMemberPrice(dish)
    const memberPriceStr = (dish.memberPrice !== null && dish.memberPrice !== undefined) ? dish.memberPrice.toString() : null;
    // const isUseAddDiscount = dish.isMember && dish.isUserMember && dish.memberPrice && ableAddPriceDiscount;
    const isUseAddDiscount = dish.isMember && dish.isUserMember && memberPriceStr && ableAddPriceDiscount; // 消除memberPrice为0的影响
    const afterAddDiscountPrice = helper.getTotalMemberPrice(dish);  // 会员折扣 加价折扣后总价
    // let nowDishPrice = dishPrice - marketPrice + dishMemberPrice; // 最新总价格
    let nowDishPrice = isUseAddDiscount ? afterAddDiscountPrice : (dishPrice - marketPrice + dishMemberPrice); // 最新总价格
    let allowDishMemberPrice = marketPrice > dishMemberPrice && dishMemberPrice >= 0; // 是否满足展示条件
    // let price = allowDishMemberPrice ? nowDishPrice : dishPrice;
    if (isHDL && isdiscount) {
      if (reduceprice !== 0) {
        sessionStorage.setItem('reducePrice', reduceprice);
        sessionStorage.setItem('reducePriceNum', dish.order);
        sessionStorage.setItem('reducePriceKey', dish.key);
      }
      dishPrice = formatPrice(formatPrice(helper.getDishPrice(dish)) - reduceprice); // 总价格
      dishMemberPrice = dish.isMember ? formatPrice(helper.getDishMemberPrice(dish) * dishCount) : -1; // 会员价基准价格
      marketPrice = formatPrice(dish.marketPrice * dishCount); // 非会员价基准价格
      nowDishPrice = isUseAddDiscount ? afterAddDiscountPrice : formatPrice(dishPrice - marketPrice + dishMemberPrice); // 最新总价格
      allowDishMemberPrice = marketPrice > dishMemberPrice && dishMemberPrice >= 0; // 是否满足展示条件
      // price = allowDishMemberPrice ? nowDishPrice : dishPrice;
    }
    const { minimum, msg, count } = mustOrderInfo || {};
    let realMin = undefined;
    // 如果总的份数小于等于必点菜的最小数量，则不能再减少了
    if (minimum && count <= minimum) {
      realMin = minimum;
    }
    const formal = isFormalMeal(Number(sessionStorage.getItem('diningForm'))) && type !== 'WM';

    return (
      <div className="cart-ordered-dish">
        <div className="ordered-dish">
          {hasProps ? (
            <a className={classnames('dish-name dish-name--trigger', { 'is-open': expand })} onTouchTap={this.onExpandBtnTap}>
              <span className="dish-name-inner">
                {helper.generateDishNameWithUnit(dish)}
                {dish.mustSelect && formal && !addDishes && (
                  <span className="badge-must-order">
                    {dish.strategyType === 3 ? formatMessage(dishMenuMessages.selfChoose) : formatMessage(dishMenuMessages.mustOrder)}
                  </span>
                )}
              </span>
            </a>
          ) : (
            <span className="dish-name">
              {helper.generateDishNameWithUnit(dish)}
              {dish.mustSelect && formal && !addDishes && (
                <span className="badge-must-order">
                  {dish.strategyType === 3 ? formatMessage(dishMenuMessages.selfChoose) : formatMessage(dishMenuMessages.mustOrder)}
                </span>
              )}
            </span>
          )}
          {isHDL && !isdiscount ? (
            allowDishMemberPrice ? (
              <span className="dish-price price ellipsis" style={{ textDecoration: 'line-through', color: '#999' }}>
                {dishPrice}
              </span>
            ) : null
          ) : null}
          {isHDL && isdiscount && reduceprice !== 0 ? (
            allowDishMemberPrice && this.props.isMember ? (
              <span className="dish-price price ellipsis" style={{ textDecoration: 'line-through', color: '#999' }}>
                {dishMemberPrice}
              </span>
            ) : (
              <span className="dish-price price ellipsis" style={{ textDecoration: 'line-through', color: '#999' }}>
                {dishPrice + reduceprice}
              </span>
            )
          ) : null}
          {!isHDL && (
            <span className="dish-price dish-price--delete o-fz--12 ellipsis">
              {allowDishMemberPrice && this.props.isMember ? <span className="price">{dishPrice}</span> : false}
            </span>
          )}
          <span className="dish-price price ellipsis">{allowDishMemberPrice && this.props.isMember ? nowDishPrice : dishPrice}</span>
          <Counter
            count={dishCount}
            onCountChange={this.onOrderBtnTap}
            step={dish.stepNum}
            showHandleInput={showHandleInput}
            dishItem={dishItem}
            minimum={realMin}
            msg={msg}
            ifShowToolTip
          />
        </div>
        {expand ? detailInfo : false}
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/dish-menu/cart/cart-ordered-dish.jsx